module.exports = __webpack_public_path__ + "static/media/LeftNav_Icon_Delegates.89df6eee.svg";